module.exports = __webpack_public_path__ + "img/bg-picture-4.b5237dd6.jpg";